<route>
{
  "meta": {
    "customSite": true
  }
}
</route>
<template>
  <Login />
</template>

<script>
import Login from '@implicit-web/auth/src/pages/m/login.vue';

export default {
  name: 'Loginf',
  components: { Login },
};
</script>
